// extracted by mini-css-extract-plugin
export var activityContainer = "_iv-0";
export var typingIndicatorContainer = "_iv-1";
export var typingIndicatorDot = "_iv-2";
export var wave = "_iv-3";